// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PendingRefundsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/pending_refunds/{periodId}
 *
 * Dados shape: Object with refunds array, summary_by_user array, and total_pending.
 */
import type { Payroll_RefundRow } from './Payroll_RefundRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PendingRefundsResponseDados {
refunds: Payroll_RefundRow[]
summary_by_user: unknown[]
total_pending: number
}

export type Payroll_PendingRefundsResponse = ApiResponse<Payroll_PendingRefundsResponseDados>;

registerResponseContract('Payroll_PendingRefundsResponse', {
  refunds: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: true },
      pays_to:               { type: 'string',  required: true },
      franchise_id:          { type: 'number',  required: true },
      title:                 { type: 'string',  required: true },
      description:           { type: 'string',  required: false },
      amount:                { type: 'string',  required: true },
      expense_date:          { type: 'string',  required: true },
      blob_name:             { type: 'string',  required: true },
      status:                { type: 'number',  required: true },
      accepted_at:           { type: 'string',  required: false },
      accepted_by:           { type: 'string',  required: false },
      declined_at:           { type: 'string',  required: false },
      declined_by:           { type: 'string',  required: false },
      decline_reason:        { type: 'string',  required: false },
      despesa_id:            { type: 'number',  required: false },
      payroll_period_id:     { type: 'number',  required: false },
      created_at:            { type: 'string',  required: true },
      created_by:            { type: 'string',  required: true },
      updated_at:            { type: 'string',  required: false },
      request_date:          { type: 'string',  required: false },
      file_url:              { type: 'string',  required: false },
      linked_despesa_status: { type: 'number',  required: false },
    },
  },
  summary_by_user: { type: 'array',   required: true },
  total_pending:   { type: 'number',  required: true },
})
